import Video from '../../src/legacy/Video.tsx';
export default Video;
